"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = Divider;
var _react = _interopRequireDefault(require("react"));
function Divider() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "border-b border-gray-200 my-5 w-full",
    "data-sentry-component": "Divider",
    "data-sentry-source-file": "Divider.tsx"
  });
}